class HelperService {
    excludeFiltersByNickname(filters, excludeNicknamesArray) {
        return Object.fromEntries(
            Object.entries(filters).filter(([key, value]) => !excludeNicknamesArray.includes(value.nickname))
        );
    }
}

export default new HelperService();
